import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Searchimg from "../../images/EXPLORE DIVISIONS/explore-image-other.jpg";
import CatogeriesList from "./Catogeries";
import PDFData from "./Pdfdata";

const StructuralFramework = () => {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://vfgzyrwzcc.execute-api.us-east-1.amazonaws.com/all-data",
          {
            headers: {
              "x-api-key": "154122054",
            },
          }
        );
        const data = await response.json();

        // Filter data by category and subcategory
        const filteredData = data.filter(
          (item) =>
            item.category === "AKT AUTOMOTIVE" &&
            item.subcategory === "TIRE-REINFORCEMENT"
        );

        setProducts(filteredData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleNavigate = (product) => {
    if (!product?.title?.[0]) {
      console.error("Product title is missing or invalid:", product);
      return;
    }

    const productTitleSlug = product.title[0]
      .replace(/\s+/g, "-")
      .toLowerCase();
    navigate(`/product/${productTitleSlug}`, { state: { product } });
  };

  return (
    <div className="flex flex-col md:flex-row bg-[#0c2341] text-white min-h-screen">
      <aside className="w-full md:w-1/4 rounded-lg p-0 md:p-6">
        <div className="border-t-2 border-gray-300 mt-6 p-4 flex flex-col bg-white rounded-lg">
          <CatogeriesList />
        </div>
        <div className="border-t-2 border-gray-300 mt-6 p-4 flex flex-col bg-white rounded-lg md:mb-4">
          <h2 className="text-2xl font-bold mb-2 text-black text-center">
            CONSULT OUR EXPERTS
          </h2>
          <p className="text-gray-800 text-sm mb-4">
            Regardless of your industry, we’ll deliver solutions and recommend
            the products you need to succeed.
          </p>
          <Link to="/contact-us">
            <button className="px-6 w-full py-2 border-2 border-[#0C2340] text-[#0C2340] hover:bg-[#1B365D] hover:text-white font-semibold rounded-lg transition duration-300">
              ASK OUR EXPERT
            </button>
          </Link>
          <img
            src={Searchimg}
            alt="Product Search"
            className="mt-4 w-full md:w-full md:min-h-[500px] h-auto"
          />
        </div>
        <div>
          <PDFData />
        </div>
      </aside>

      <main className="flex-1 p-0 sm:p-4 md:!p-6 lg:!p-8 xl:!p-10 py-2">
        <h1 className="text-base md:text-2xl md:mb-10 py-2">
          <Link to="/">Home</Link> / AKT AUTOMOTIVE /{" "}
          <span className="font-bold">TIRE-REINFORCEMENT</span>
        </h1>
        <h1 className="text-2xl md:text-4xl font-bold">
          Akt Tire-Reinforcement
        </h1>

        {/* Render Filtered Data */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6 w-full">
          {products.length > 0 ? (
            products.map((item, index) => (
              <div
                key={index}
                onClick={() => handleNavigate(item)}
                className="bg-[#3a506f] hover:bg-[#f3f4f6] hover:text-gray-900 p-3 rounded-lg cursor-pointer flex flex-col h-full transition-all duration-300"
              >
                {/* <img
                  src={`${item.imageUrl}?t=${new Date().getTime()}`}
                  alt={item.title}
                  className="w-full h-64 object-cover rounded hover:scale-105 duration-300 ease-in-out"
                /> */}
                {/* ...........img.......... */}
                <div className="w-full h-60 bg-[#f3f4f6] rounded relative overflow-hidden flex items-center justify-center">
                  <img
                    src={`${item.imageUrl}?t=${new Date().getTime()}`}
                    alt={item.title?.[0]}
                    className="w-full h-60 absolute top-0 left-0 transition-opacity duration-500"
                    onLoad={(e) => {
                      e.target.style.opacity = '1';
                      e.target.nextElementSibling.style.display = 'none'; // Hide spinner
                    }}
                    style={{ opacity: 0 }}
                  />
                  {/* Centered spinner while loading */}
                  <div className="spinner absolute"></div>
                </div>

                <style>
                  {`
                                  .spinner {
                                     border: 2px solid #e5e7eb; 
                                     border-top: 2px solid #0c2341; 
                                     border-radius: 50%;
                                     width: 40px;
                                     height: 40px;
                                     animation: spin 1s linear infinite;
                                    }

                                     @keyframes spin {
                                     0% { transform: rotate(0deg); }
                                     100% { transform: rotate(360deg); }
                                   }
                                  `}
                </style>
                {/* ...........img.......... */}
                <h3 className="font-bold mt-2 text-2xl py-2 line-clamp-1">
                  {item.title?.[0]}
                </h3>

                {/* Description Section (Will Push the Button Down) */}
                {/* <p className="text-base text-justify overflow-hidden max-h-24">
                  {item.descriptions?.[0]}
                </p> */}

                <div
                  className="text-base text-justify overflow-hidden line-clamp-5"
                  dangerouslySetInnerHTML={{ __html: item.descriptions?.[0] }}
                ></div>

                <button
                  onClick={() => handleNavigate(item)}
                  className="px-3 py-2 w-full mt-3 bg-white border-2 border-[#0C2340] text-[#0C2340] 
                                  hover:!bg-[#0c2341] hover:text-white font-semibold rounded-lg transition duration-300"
                >
                  Read More
                </button>
              </div>
            ))
          ) : (
            <p className="text-center text-lg col-span-3 mt-10">
              Please Wait . . . .
            </p>
          )}
        </div>
      </main>
    </div>
  );
};

export default StructuralFramework;
